import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./ToolDraw.css";
import { getIcon } from "../../../utils/icons";
import { setCommandType, resetOperation, setCommandMessage, setDrawMethod } from "../../../redux/operationSlice";
import { COMMANDS, DRAW_METHODS } from "../../../utils/commonProperties";

const DROPDOWN_TOOLS = ['circle', 'arc', 'ellipse', 'rect'];

const ToolDraw = () => {
  const [activeButton, setActiveButton] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0, width: 0 });
  const buttonSize = 30;
  const dispatch = useDispatch();
  const commandType = useSelector((state) => state.operation.commandType);
  const drawMethod = useSelector((state) => state.operation.drawMethod);
  const wrapperRef = useRef(null);
  const toolBtnRefs = useRef({});

  useEffect(() => {
    switch (commandType) {
      case COMMANDS.DRAW_LINE: setActiveButton("line"); break;
      case COMMANDS.DRAW_POLYLINE: setActiveButton("polyline"); break;
      case COMMANDS.DRAW_SPLINE: setActiveButton("spline"); break;
      case COMMANDS.DRAW_CIRCLE: setActiveButton("circle"); break;
      case COMMANDS.DRAW_ARC: setActiveButton("arc"); break;
      case COMMANDS.DRAW_ELLIPSE: setActiveButton("ellipse"); break;
      case COMMANDS.DRAW_RECT: setActiveButton("rect"); break;
      default: setActiveButton(null);
    }
  }, [commandType]);

  // Dropdown disina tiklaninca kapat
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleClick = (tool) => {
    const alreadyActive = tool === activeButton;
    if (alreadyActive) {
      dispatch(resetOperation());
      setActiveButton(null);
    } else {
      dispatch(setDrawMethod(null));
      setActiveButton(tool);
      dispatch(setCommandType(COMMANDS[`DRAW_${tool.toUpperCase()}`]));
      dispatch(setCommandMessage("İlk noktayı seçin"));
    }
  };

  const handleDropdownToggle = (e, tool) => {
    e.stopPropagation();
    const willOpen = openDropdown !== tool;
    setOpenDropdown(prev => prev === tool ? null : tool);
    if (willOpen && toolBtnRefs.current[tool]) {
      const rect = toolBtnRefs.current[tool].getBoundingClientRect();
      setDropdownPos({ top: rect.bottom + 2, left: rect.left, width: rect.width });
    }
  };

  const handleMethodSelect = (tool, methodKey) => {
    dispatch(setDrawMethod(methodKey));
    setOpenDropdown(null);
    setActiveButton(tool);
    dispatch(setCommandType(COMMANDS[`DRAW_${tool.toUpperCase()}`]));
    dispatch(setCommandMessage("İlk noktayı seçin"));
  };

  const renderToolButton = (tool) => {
    const hasDropdown = DROPDOWN_TOOLS.includes(tool);
    const methods = hasDropdown ? DRAW_METHODS[tool] : null;

    if (hasDropdown) {
      return (
        <div key={tool} className="tool-btn-wrapper" ref={el => { toolBtnRefs.current[tool] = el; }}>
          <button
            className={`toolButton ${activeButton === tool ? "active" : ""}`}
            style={{ width: `${buttonSize}px`, height: `${buttonSize}px` }}
            onClick={() => handleClick(tool)}>
            {getIcon(tool, buttonSize)}
          </button>
          <button
            className="tool-dropdown-arrow"
            onClick={(e) => handleDropdownToggle(e, tool)}>
            ▾
          </button>
          {openDropdown === tool && (
            <div className="tool-dropdown-menu" style={{ top: dropdownPos.top, left: dropdownPos.left, minWidth: dropdownPos.width }}>
              {methods.map((m, idx) => (
                <button
                  key={m.key}
                  className={`tool-dropdown-item ${drawMethod === m.key || (!drawMethod && idx === 0) ? 'active' : ''}`}
                  onClick={() => handleMethodSelect(tool, m.key)}>
                  <span className="tool-dropdown-check">{drawMethod === m.key || (!drawMethod && idx === 0) ? '✓' : ''}</span>
                  {m.label}
                </button>
              ))}
            </div>
          )}
        </div>
      );
    }

    return (
      <button key={tool}
        className={`toolButton ${activeButton === tool ? "active" : ""}`}
        style={{ width: `${buttonSize}px`, height: `${buttonSize}px` }}
        onClick={() => handleClick(tool)}>
        {getIcon(tool, buttonSize)}
      </button>
    );
  };

  return (
   <div className={`toolDraw ${isOpen ? "open" : "closed"}`} ref={wrapperRef}>
  {/* Sol kolon: butonlar */}
  {isOpen && (
    <div className="toolDraw-left">
      <div className="toolRow">
        {["line", "polyline", "spline", "circle"].map(renderToolButton)}
      </div>
      <div className="toolRow">
        {["arc", "ellipse", "rect"].map(renderToolButton)}
      </div>
    </div>
  )}

  {/* Sağ kolon: toggle butonu */}
  <div className="toolDraw-toggle">
    <button
      className="toolButton toggleArrowButton"
      onClick={() => setIsOpen((prev) => !prev)}
    >
      {isOpen ? "◀" : "Draw▶"}
    </button>
  </div>
</div>

  );
};

export default ToolDraw;
